import { loadStripe } from "@stripe/stripe-js";

// Set stripe key to whatever is passed in the environment or default to test
const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY || "";

export const stripePromise = loadStripe(STRIPE_KEY);
